var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.balance)?_c('span',[_vm._v(" (max "),_c('a',{staticClass:"color-gray-6",on:{"click":_vm.select}},[_c('Amount',{attrs:{"asset":_vm.decimals_asset || _vm.asset,"value":_vm.balance}})],1),_vm._v(") ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }